import React from 'react';

const ModalDescription = (props: React.HTMLAttributes<HTMLParagraphElement>): JSX.Element => <p {...props} />;

ModalDescription.displayName = 'ModalDescription';

export default ModalDescription;
